<template>
  <div
    v-if="!accessPermission"
    class="bgc-white flex-fill flex flex-column h-center"
    style="height: calc(100% - 15px);"
  >
    <div class="clr-blue" style="font-size: 80px; padding: 24px;">
      <i class="el-icon-warning-outline" />
    </div>
    <h4>很抱歉！分享已失效</h4>
    <div
      class="flex-fill flex flex-column v-bottom"
      style="width: 100%; padding: 20px;"
    >
      <div class="flex-auto flex flex-row v-center h-center">
        <van-button type="info" block @click="goBack">返回</van-button>
      </div>
    </div>
  </div>
  <div v-else class="flex-fill flex flex-column">
    <share-answer-mobile
      v-if="`${shareType}` === '3'"
      :form="form"
      :answer="answer"
      :items="items"
      :source-channel="sourceChannel"
      :os="os"
      :tags="tags"
      :creator-name="answerCreatorName"
      @back-parent="goBack"
    />
  </div>
</template>
<script>
import { Button } from "vant";

import ShareAnswerMobile from "@/components/share/ShareAnswerMobile";
import { mapGetters, mapState } from "vuex";
import store from "@/store";
import ErrorHandler from "@/utils/ErrorHandler";
export default {
  name: "share-mobile-page",
  components: { ShareAnswerMobile, [Button.name]: Button },
  computed: {
    ...mapGetters({
      answerCreatorName: "share/answerCreatorName",
      sourceChannel: "share/sourceChannel",
      os: "share/os",
      tags: "share/tags",
      items: "share/readonlyItems",
    }),
    ...mapState({
      form: (state) => state.share.form.base,
      answer: (state) => state.share.answer.base,
      shareType: (state) => state.share.status.type,
      accessPermission: (state) => state.share.status.allowedAccess,
    }),
  },
  data() {
    return {
      delay: 3,
      interval: null,
      visible: false,
      shareId: "",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { dispatch, state } = store;
      const { uniqueId } = to.params;
      if (uniqueId) {
        await dispatch("share/obtainStatus", { uniqueId });
        const { type, allowedAccess } = state.share.status;
        if (allowedAccess) {
          // 如果允许访问 先获取form base
          await dispatch("share/obtainFormBase", { uniqueId });
          if (type === 1) {
            // form
          }
          if (type === 2) {
            // version
          }
          if (type === 3) {
            // answer
            await dispatch("share/obtainFormItems", { uniqueId });
            await dispatch("share/obtainAnswer", { uniqueId });
          }
        }
      }
      next();
    } catch (e) {
      ErrorHandler(next)(e);
    }
  },
};
</script>
